import { IAboutData } from "@/interfaces/IAboutUsData";
import { AboutUsBanner, PowerofFourSection, WhatWeTreatText, WhoWeAreSection } from ".";
import { WhatCanWeHelp } from "../category";
import { WhatWeTreat } from "../homePage";

type props = {
    aboutData: IAboutData
}
export function AboutUs({ aboutData }: props) {
    return <>
        <AboutUsBanner bannerData={aboutData.aboutDetails}/>
        <WhoWeAreSection whoWeAreData={aboutData.aboutDetails}/>
        <PowerofFourSection powerOfFour={aboutData.aboutDetails}/>
        <WhatWeTreat categories={aboutData.categories}/>
        <WhatWeTreatText whatWeTreatText={aboutData.aboutDetails}/>
    </>
}